import { Button, Dialog, DialogActions } from '@material-ui/core'
import DialogContent from '@material-ui/core/DialogContent'
import React, { Component } from 'react'

export class DialogView extends Component {
  render () {
    const { content, show, maxWidth, showPrint, confirmCallback, cancelCallback, closeSelf } = this.props.state
    return (
      <Dialog
        open={show}
        onClose={closeSelf}
        aria-labelledby='form-dialog-title'
        maxWidth={maxWidth}
        fullWidth
      >
        <DialogContent style={{ overflowY: 'visible' }}>
          {typeof content === 'function' ? content() : content}
        </DialogContent>
        <DialogActions>
          {showPrint && <Button onClick={() => window.print()} color='primary'>
            Imprimir
          </Button>}
          {cancelCallback && <Button onClick={cancelCallback} color='secondary'>
            Cancelar
          </Button>}
          {confirmCallback && <Button onClick={confirmCallback} color='primary'>
            Aceptar
          </Button>}
        </DialogActions>
      </Dialog>
    )
  }
}
